export const addGlobalMessageRequested = (message) => ({
  type: "ADD_GLOBAL_MESSAGE_REQUESTED",
  message
});

export const addGlobalMessage = (message) => ({
  type: "ADD_GLOBAL_MESSAGE",
  message
});

export const removeGlobalMessage = (id) => ({
  type: "REMOVE_GLOBAL_MESSAGE",
  id
});

export const clearGlobalMessages = () => ({
  type: "CLEAR_GLOBAL_MESSAGES"
});

export const setMaintenanceMode = (value) => ({
  type: "SET_MAINTENANCE_MODE",
  value
});

export const checkMaintenanceModeStatus = () => ({
  type: "CHECK_MAINTENANCE_MODE_STATUS"
});

export const registerDeviceFcmToken = (token) => ({
  type: "REGISTER_DEVICE_FCM_TOKEN_REQUESTED",
  token
});

export const unregisterDeviceFcmToken = (token) => ({
  type: "UNREGISTER_DEVICE_FCM_TOKEN_REQUESTED",
  token
});

export const setNetworkOffline = (value) => ({
  type: "SET_NETWORK_OFFLINE",
  value
});

export const setOpenModal = (value, params) => ({
  type: "SET_OPEN_MODAL",
  value,
  params
});